import { API_ROOT_URL } from '../../utils/constants'

async function getHeader() {
    let token = await window.sessionStorage.getItem('token')
    let header = new Headers();
    header.append("Content-Type", "application/json");
    header.append("Authorization", `Bearer ${token}`);
    return header
}

async function getByParams(endpoint, params) {

    try {

        let header = await getHeader()
        let options = {
            method: 'GET',
            headers: header
        };
        
        let url = new URL(`${API_ROOT_URL}${endpoint}/`);
        if (params) Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        
        console.log(url)
        
        let response = await fetch(url, options);
        
        let data = await response.json();
        
        if (response.ok)
        return data;
        else throw data;
    } catch (e) {
        
        throw e;
    }
    
}

async function postData(endpoint, values) {
    try {
        let header = await getHeader()
        
        let options = {
            method: 'POST',
            headers: header,
            body: JSON.stringify(values)
        };
        let root = API_ROOT_URL
        if (endpoint === 'token') {
          root = API_ROOT_URL.replace("/api/v1/", "/")
        }
        let url = new URL(`${root}${endpoint}/`)

        let response = await fetch(url, options);
        
        let data = await response.json();
        
        if (response.ok)
        return data;
        else throw data;
    } catch (e) {
        throw e;
    }
}

async function putData(endpoint, values) {
    try {
        
        let header = await getHeader()
        let options = {
            method: 'PUT',
            headers: header,
            body: JSON.stringify(values)
        };
        let url = new URL(`${API_ROOT_URL}${endpoint}`)
        let response = await fetch(url, options);

        let data = await response.json();

        if (response.ok)
            return data;
        else throw data;
    } catch (e) {
        throw e;
    }
}
export const ServiceBase = {
    getByParams,
    postData,
    putData
}
